import Toggle from './Toggle';
import './Toggle.scss';

export default Toggle;